import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../Layout/Footer';
import Header from '../Layout/Header';
import Contactus from '../../assets/img/contact-us.jpg';

const ContactUs = () => {
    return (
        <React.Fragment>
            <Header />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>Contact Us </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name">Contact Us</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='contacts'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12'>

                            <div className='row'>
                                <div className='col-lg-6'>
                                    <div className="contact-form-wrapper-left">
                                        <div className='contacts-title'>
                                            <h4>Contact Us</h4>
                                        </div>
                                        <div className="contact-details mt-5">
                                            <h5 className="title">Email ID</h5>
                                            <p className="description">support@taskde.com</p>
                                        </div>
                                        <div className="contact-details">
                                            <h5 className="title">Phone Number</h5>
                                            <p className="description">05514025324</p>
                                        </div>
                                        <div className="contact-details">
                                            <h5 className="title">Location</h5>
                                            <p className="description">
                                                Taskde Private Limited
                                                655G, Maruti Bhawan, Basaratpur, Gorakhpur,
                                                India, Uttar Pradesh - 273004
                                            </p>
                                        </div>
                                        {/* <div className="contact-details">
                                            <h5 className="title">Opening Hours</h5>
                                            <p className="description">Mon-Sat <span className='ms-2'>07:00am - 07:00pm</span></p>
                                        </div> */}
                                    </div>
                                </div>
                                <div className='col-lg-6'>
                                    <div className="contact-form-wrapper d-flex justify-content-center p-0">
                                        {/* <div className="contact-form">
                                            <h5 className="title">Enquiry</h5>
                                            <p className="description">Feel free to contact us if you need any assistance, any help or another question.</p>
                                            <div>
                                                <input type="text" className="form-control rounded border-white mb-3 form-input" id="name" placeholder="Name" required />
                                            </div>
                                            <div>
                                                <input type="tel" className="form-control rounded border-white mb-3 form-input" placeholder="Mobile No" required />
                                            </div>
                                            <div>
                                                <input type="email" className="form-control rounded border-white mb-3 form-input" placeholder="Email" required />
                                            </div>
                                            <div>
                                                <textarea className="form-control rounded border-white mb-3 form-text-area" id="exampleFormControlTextarea1" rows="3" placeholder="Message" required />
                                            </div>
                                            <div className="submit-button-wrapper">
                                                <input type="submit" value="Submit" />
                                            </div>
                                        </div> */}
                                        <div>
                                            <img src={Contactus} alt="" className='img-fluid' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </React.Fragment>
    )
}

export default ContactUs;